import FileUploadErrorType from '../enums/FileUploadErrorType';
export const STATUS_TO_UPLOAD_ERROR_TYPE = {
  413: FileUploadErrorType.FILE_TOO_LARGE,
  403: FileUploadErrorType.MISSING_WRITE_SCOPE,
  500: FileUploadErrorType.SERVER_ERROR,
  502: FileUploadErrorType.SERVER_ERROR,
  503: FileUploadErrorType.SERVER_ERROR,
  504: FileUploadErrorType.TIMEOUT
};
function isFileUploadErrorType(errorType) {
  return errorType && errorType in FileUploadErrorType;
}
export const isNetworkError = err => {
  return err.status === 0;
};
export const getUploadErrorType = err => {
  if (isNetworkError(err)) {
    return FileUploadErrorType.NETWORK_ERROR;
  }
  if (err.responseJSON) {
    const json = err.responseJSON;
    if (isFileUploadErrorType(json.errorType)) {
      return json.errorType;
    } else if (isFileUploadErrorType(json.message)) {
      return json.message;
    }
  }
  return STATUS_TO_UPLOAD_ERROR_TYPE[err.status] || null;
};